<template>
  <div class="medication-info">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          large
          class="medication-info__icon"
          :color="color"
          v-bind="attrs"
          v-on="on"
        >{{errorInfo ? 'mdi-alert-circle': 'mdi-check-decagram'}}</v-icon>
      </template>
      <div
        v-for="(message, i) in messages"
        :key="`message-${i}`"
      >{{ message }}</div>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * Component MedicationInfo.vue
 *
 * @module MedicationInfo
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationInfo.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationInfo',
  props: {
    color: {
      type: String,
      required: true,
    },
    messages: {
      type: Array,
      required: true,
    },
    errorInfo: {
      type: Boolean
    }
  },
};
</script>

<style>
.medication-info {
  margin-left: 10px;
}
</style>
